import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6cc1ea5e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6cc1ea5e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc1ea5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cc1ea5e')) {
      api.createRecord('6cc1ea5e', component.options)
    } else {
      api.reload('6cc1ea5e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6cc1ea5e&scoped=true", function () {
      api.rerender('6cc1ea5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/CommunityDynamics/PraiseRank/index.vue"
export default component.exports